var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"cms-block cms-block-button",class:_vm.classes},[_c('a',{class:[
            'button',
            `button--${_vm.block.value.button_style.toLowerCase()}`
        ],attrs:{"href":_vm.block.value.url}},[_vm._v(" "+_vm._s(_vm.block.value.title)+" ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }